<div
  class="border-itinerary"
  [class.fare]="hasFare"
  [class.check-segment]="segment.isChecked"
  [class.hover-segment]="segment.isHovered"
>
  <app-accordion
    [showArrow]="true"
    theme="segment"
    [arrowRight]="true"
    [arrowBottom]="true"
    [is11Title]="true"
    [borderedBottom]="true"
    maxHeight="151vh"
    [hasExtraRow]="!!segment.recommendationFlights?.length"
    [isVcentered]="false"
    [size]="!!segment.recommendationFlights?.length ? '13rem' : '10.2rem'"
  >
    <!-- Header-->
    <div class="p-itinerary" title>
      <app-segment-header
        [flights]="
          !!segment.recommendationFlights?.length
            ? recommendationFlightsForChange
            : segment?.flights
        "
        [segment]="segment"
        [showSeatsAvailability]="showSeatsAvailability"
        [isInvoluntary]="isInvoluntary"
        [index]="index"
        [isAirline]="isAirline$"
        [showBaggage]="!isExchangeFlight"
        [baggageAllowance]="baggageAllowance"
        [isMultidestiny]="isMultidestiny"
        (click)="click()"
        (mouseenter)="over()"
        (mouseleave)="leave()"
      >
      </app-segment-header>
    </div>

    <!-- Rescheduled status-->

    <div class="status" arrow-extra>
      <span
        *ngIf="false"
        attr.data-title-long-left="{{ 'itinerary-actions.not-emited' | translate }}"
      >
        <em class="mdi mdi-alert mdi-24px has-text-warning" aria-hidden="true"></em>
      </span>
      <span
        *ngIf="false"
        attr.data-title-long-left="{{ 'itinerary-actions.not-emited' | translate }}"
      >
        <em
          class="mdi mdi-checkbox-marked-circle mdi-24px has-text-success"
          aria-hidden="true"
        ></em>
      </span>
    </div>

    <!-- Rescheduled Content-->
    <div
      *ngIf="!!segment.recommendationFlights?.length || (isAirline$ && segment.isAffected)"
      class="p-itinerary"
      content
    >
      <div
        class="columns is-mobile is-centered is-vcentered rescheduled-section"
        *ngIf="!!segment.recommendationFlights?.length || (isAirline$ && segment.isAffected)"
        extra
      >
        <div class="column is-narrow">
          <app-input-submit
            [disabled]="(showButtonConfirmrescheduled && isAirline$) || !hasSelectedPassengers"
            inputText="{{ 'itinerary-info.flight.confirm-rescheduled' | translate }}"
            (clickButton)="openSyncForm.emit(segment)"
          ></app-input-submit>
        </div>
        <div class="column is-narrow">
          <app-input-submit
            [isWhite]="true"
            inputText="{{ 'itinerary-info.flight.itinerary-compare' | translate }}"
            (clickButton)="showModalOriginalFlight = true"
          ></app-input-submit>
        </div>
        <div class="column is-narrow">
          <app-input-submit
            [isWhite]="true"
            inputText="{{ 'itinerary-info.flight.load-alternatives' | translate }}"
            (clickButton)="loadSegmentAlternatives()"
          ></app-input-submit>
        </div>
      </div>
    </div>

    <!--CONTENT  -->
    <div class="p-itinerary" content>
      <app-flights
        [flights]="
          !!segment.recommendationFlights?.length
            ? recommendationFlightsForChange
            : segment?.flights
        "
        [showBaggage]="isExchangeFlight && !isInvoluntary"
        [isInvoluntary]="isInvoluntary"
        [isHeader]="isHeader"
        [isExchangeFlight]="isExchangeFlight"
        [mode]="mode"
        [associatedFlight]="segment?.associatedFlight"
        [checkedHide]="segment?.isChecked"
        [canSelect]="canSelect && segment?.canSelectFlights"
        (selectFlights)="selectFlight($event)"
        (selectAll)="typeSelect($event)"
        (changeClass)="changeClass.emit($event)"
      >
      </app-flights>
    </div>
  </app-accordion>
</div>

<app-modal
  [isActive]="showModalOriginalFlight"
  (modalState)="showModalOriginalFlight = false"
  [isLarge]="true"
>
  <p class="modal-card-title" modal-title>
    {{ 'involuntary-change.rescheduled-flight' | translate }}
  </p>
  <app-segment-resume-comparision
    [rescheduledOriginalFlights]="rescheduledOriginalFlights"
    [rescheduledRecommendationFlights]="rescheduledRecommendationFlights"
    modal-content
  >
  </app-segment-resume-comparision>
</app-modal>
